import { render, staticRenderFns } from "./FiltersMenu.vue?vue&type=template&id=6d3bbc1c&scoped=true"
import script from "./FiltersMenu.vue?vue&type=script&lang=ts"
export * from "./FiltersMenu.vue?vue&type=script&lang=ts"
import style0 from "./FiltersMenu.vue?vue&type=style&index=0&id=6d3bbc1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3bbc1c",
  null
  
)

export default component.exports